function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.608 15.898a2.449 2.449 0 1 0 0-4.898 2.449 2.449 0 0 0 0 4.898zM23.301 13.087h-9.424a.448.448 0 1 1 0-.897h9.424a.448.448 0 1 1 0 .897zM14.873 17.47H5.448a.448.448 0 1 1 0-.896h9.425a.448.448 0 1 1 0 .896zM7.978 22.083c0 .247.201.448.449.448h9.424a.448.448 0 0 0 0-.896H8.427c-.248 0-.449.2-.449.448z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.321 16.187c2.026 1.203 3.91.975 5.316-.995.918-1.285 3.063-.052 2.135 1.248-1.794 2.513-4.314 3.47-6.964 2.657a98.084 98.084 0 0 0-2.38 4.35c1.121.574 2.443 1.584 3.124 2.127.678.54 1.507 2.351 2.144 3.742.162.353.31.678.442.95.696 1.439-1.545 2.483-2.239 1.05-.135-.28-.292-.624-.46-.994-.544-1.194-1.207-2.648-1.635-3-.561-.462-2.401-1.764-3.805-2.253a1.347 1.347 0 0 1-.192-.085c-1.719 2.181-5.085 3.211-7.956 1.534-1.513-.884-.145-3.064 1.373-2.177 2.103 1.23 4.291-.343 5.283-2.312.99-1.968 1.693-3.354 2.496-4.749-1.568-.5-3.003-.043-4.131 1.537-.918 1.285-3.064.052-2.136-1.248 2.184-3.057 5.44-3.816 8.7-1.881.068.04.256.146.445.25.186.105.371.209.44.25z",
  fill: "currentColor"
});

var SvgAudienceFitness = function SvgAudienceFitness(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAudienceFitness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audience_fitness.03ca3ddb.svg";
export { ForwardRef as ReactComponent };